import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {actionCreators as treatmentActionCreators} from '../../store/Treatments'
import {actionCreators as languageActionCreators} from '../../store/Languages'
import 'semantic-ui-css/semantic.min.css'
import {
    Segment,
    Form,
    Button,
    TransitionablePortal,
} from 'semantic-ui-react'
import AccordionSegment from '../common/ui/AccordionSegment'
import Loading from '../common/ui/Loading'
import moment from 'moment'
import GridFormInput from '../common/ui/TableGridFormInput'
import 'jsoneditor-react/es/editor.min.css';
import 'brace/mode/json';
import 'brace/theme/github';
import AppBreadCrumb from "../common/ui/AppBreadCrumb";
import AppMessage from "../common/ui/AppMessage";

class MasterTreatment  extends Component {
    state = {
        filter: {},
        page: 1,
        modalOpen: false,
        newTopic: {},
        treatment: {},
        edit: false,
        loading: true,
        saving: -1
    }

    componentWillMount() {
        this.props.getMasterTreatment(this.props.match.params.id)
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({treatment: nextProps.treatments.mastertreatment, loading: !this.state.treatment})
    }

    onPageChange = (e, data) => {
        this.setState({page: data.activePage})

    }

    toggleMessage() {
        setTimeout(() => this.setState({saving: -1}), 3000)
    }

    async handleSave() {
        this.setState({saving: 1})
        let treatment = {
            name: this.state.treatment.name,
            data: this.state.treatment.data,
            protocol_type: this.state.treatment.protocol_type
        }
        let errors = await this.props.updateMasterTreatment(this.props.match.params.id, treatment)
        if (errors !== undefined) {
            this.setState({saving: 2, errors})
        } else {
            await this.props.getMasterTreatment(this.props.match.params.id)
            this.setState({edit: false, saving: 0})
            this.toggleMessage()
        }
    }

    handleEdit = () => {
        this.setState({edit: true})
    }

    handleCancel = () => {
        this.props.getMasterTreatment(this.props.match.params.id)
        this.setState({edit: false})
    }

    handleChange = (e, target) => {
        if (this.state.edit) {
            let treatment = this.state.treatment
            treatment[target.name] = target.name === "active" || target.name === "required" ? target.checked ? 1 : 0 : target.value
            this.setState({treatment})
        }
    }

    handleJSONChange = (e, target) => {
        if (this.state.edit) {
            let treatment = this.state.treatment
            treatment['data'] = e
            this.setState({treatment})
        }
    }


    render() {
        let treatment = this.state.treatment
        let readOnly = !this.state.edit
        let createdAt = treatment.created_at ? treatment.created_at.substr(0, 16) : ""
        let updatedAt = treatment.updated_at ? treatment.updated_at.substr(0, 16) : ""

        let isResearchAssistant = this.props.login.user.roles ? this.props.login.user.roles.find(role => role.name === 'research_assistant') : false

        return [
            <AppBreadCrumb key={0} crumbs={[{
                text: "Treatments",
                link: "/app/treatments"
            }, {
                text: "Treatment",
            }]}/>,
            <AccordionSegment backgroundColor={'#80e4d530'} key={1} header={'Treatment'} component={
                <div>
                    <TransitionablePortal open={this.state.saving !== -1}>
                        <Segment
                            style={{left: '48%', position: 'fixed', top: '30px', zIndex: 1000, padding: 0}}>
                            <AppMessage saving={this.state.saving} errors={this.state.errors}/>
                        </Segment>
                    </TransitionablePortal>
                    {this.state.loading ? <Loading/> :
                        <Form className={readOnly ? "readOnly" : "editing"}>
                            <GridFormInput
                                label="Type"
                                component={readOnly ? treatment.name : <Form.Input
                                    fluid
                                    placeholder='Type'
                                    readOnly={readOnly}
                                    value={treatment.name}
                                    name="name"
                                    onChange={this.handleChange.bind(this)}/>}
                            />

                            {isResearchAssistant ? null :
                                <GridFormInput
                                    label="Protocol Type"
                                    component={readOnly ? treatment.protocol_type : <Form.Select
                                        fluid
                                        placeholder='Site'
                                        value={treatment.protocol_type}
                                        options={[{key: 1, text: "Active", value: "active"},
                                            {key: 2, text: "Control", value: "control"}]}
                                        name="protocol_type"
                                        onChange={this.handleChange.bind(this)}
                                    />}
                                />
                            }
                            <GridFormInput
                                label="ID"
                                component={treatment.id}
                            />

                            <GridFormInput
                                label="Created"
                                component={moment(createdAt).format('MMMM Do YYYY') + " at " + moment(createdAt).format('h:mm:ss a')}
                            />
                            <GridFormInput
                                label="Updated"
                                component={moment(updatedAt).format('MMMM Do YYYY') + " at " + moment(updatedAt).format('h:mm:ss a')}
                            />
                            <GridFormInput
                                label="Created By"
                                component={treatment.created_by
                                }
                            />
                            <GridFormInput
                                label="Updated By"
                                component={treatment.updated_by}
                            />
                            <br/>
                            {isResearchAssistant ? null : (
                                readOnly ? <Button color='teal' style={{float: "right"}}
                                                   onClick={this.handleEdit.bind(this)}>Edit</Button> :
                                    [<Button key={0} color='teal' style={{float: "right"}}
                                             onClick={this.handleSave.bind(this)}>Save</Button>,
                                        <Button key={1} style={{float: "right"}}
                                                onClick={this.handleCancel.bind(this)}>Cancel</Button>]

                            )
                            }
                            <br/>
                            <br/>
                        </Form>
                    }
                </div>}/>
        ]
    }
}

export default connect(
    state => ({searchStore: state.searchStore, treatments: state.treatments, languages: state.languages, login: state.login}),
    dispatch => bindActionCreators({...treatmentActionCreators, ...languageActionCreators}, dispatch)
)(MasterTreatment)
